<div class="container-fluid form-section content-padded">
  <div class="row">

    <div class="col-md-12 centered text-center">
      <div class="col-md-12" *ngIf="multipleLanguage" style="float:right">
        <div class="col-sm-2 float-right">
          <select id="language" name="idLanguage" class="form-control" (change)="changeLanguage()" [(ngModel)]="languageId">
            <option *ngFor="let l of languages" [ngValue]="l.idLanguage">{{l.name}}</option>
          </select>
        </div>
      </div>
      <h2 class="title-dob">{{getLabel()}}</h2>
      <div class="insert-date">
        <select class="custom-select" [(ngModel)]="birthDate.month">
          <option [ngValue]="null" disabled>Month</option>
          <option *ngFor="let month of monthsArr" [ngValue]="month">{{month | translate}}</option>
        </select>
        <select class="custom-select" [(ngModel)]="birthDate.day">
          <option [ngValue]="null" disabled>Day</option>
          <option *ngFor="let day of daysArr" [ngValue]="day">{{day}}</option>
        </select>
        <select class="custom-select" [(ngModel)]="birthDate.year">
          <option [ngValue]="null" disabled>Year</option>
          <option *ngFor="let year of yearsArr" [ngValue]="year">{{year}}</option>
        </select>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button (click)="onClickDate()" type="button"
                  class="btn btn-outline-info next-step float-right">{{'Next' | translate}}</button>
        </div>
      </div>

    </div>
  </div>
</div>
